var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxHtmlEditor',{ref:"editor",attrs:{"value":_vm.value,"read-only":_vm.readOnly,"height":_vm.height,"placeholder":_vm.placeholder,"element-attr":{ class: 'gc-html-editor' }},on:{"value-changed":_vm.onValueChanged,"focus-in":_vm.onFocusIn}},[(!_vm.readOnly)?_c('DxToolbar',{attrs:{"items":_vm.toolbarItems}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }